import React, {Suspense} from "react";
import {createRoot} from "react-dom/client";
import {useTranslation} from "react-i18next";
import Card from "../../molecules/Card";

class HomepageBannerContent {
  constructor(element: HTMLElement) {
    const root = createRoot(element);
    root.render(
      <Suspense fallback={null}>
        <HomepageBannerCard elem={element} />
      </Suspense>,
    );
  }
}

const HomepageBannerCard: React.FC<{elem: HTMLElement}> = ({elem}) => {
  const {t} = useTranslation();
  const {bannerImage, bannerImage2x, bannerSubHeadline, bannerHeadline, bannerLink} = elem.dataset;

  return (
    <Card
      image={bannerImage}
      image2x={bannerImage2x}
      categoryName={bannerSubHeadline}
      headline={bannerHeadline}
      linkText={t("general.discoverNow")}
      linkUrl={bannerLink}
      linkTitle={t("general.open--title", {title: bannerHeadline})}
      lightBackground={true}
    />
  );
};
export default HomepageBannerContent;
